// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"70bdaffa","114":"43398280","241":"b9856657","673":"bacf2f6e","715":"b9856657","722":"a73251bc","882":"b9856657","889":"a44c9991"}[chunkId] + ".chunk.css";
};